import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import { useAuth } from "../Common/Configurations/AuthContext";
import DefaultData from "../CompanyData/DefaultData";
const initialLoginValues = { username: "", password: "" };
export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [values, setValues] = useState(initialLoginValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(false);
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // ... (All handlers remain the same)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors({ ...errors, [name]: false });
    if (errors.submit) setErrors({ ...errors, submit: "" });
  };
  const validate = () => {
    let temp = {};
    temp.username = values.username !== "";
    temp.password = values.password !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  useEffect(() => {
    let host = window.location.hostname;
    if (host.startsWith("www.")) host = host.replace("www.", "");
    if (host.startsWith("admin.")) host = host.replace("admin.", "");
    if (host.startsWith("app.")) host = host.replace("app.", "");

    const tenant = host.split(".")[0];
    const allowedTenants = ["localhost", "trawtel", "zotrai"];
    setShow(allowedTenants.includes(tenant));

    localStorage.setItem("tenant",DefaultData.TENANTID); // Default tenant for all environments);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(true);
      const formData = {
        username: values.username,
        password: values.password,
        tenant: localStorage.getItem("tenant"),
      };
      try {
        const result = await apiService.post(config.MASTERLOGIN, formData);
        if (result.registrationPending) {
          navigate("/registration-pending", {
            state: {
              userEmail: result.userEmail || values.username,
              message: result.message,
            },
          });
          return;
        }
        login({
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
        });
      } catch (error) {
        const errorData = error.response?.data;
        setErrors({
          submit: errorData?.message || "Login failed. Please try again.",
        });
      } finally {
        setBtnSubmit(false);
      }
    }
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " is-invalid" : "";

  return (
    <div>
      <div className="globalsupplier-main-wrapper">
        <section
          className="globalsupplier-hero-section"
          style={{
            background: `linear-gradient(135deg, ${DefaultData.THEMECOLOR1} 0%, #0f172a 100%)`,
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-5 mb-lg-0">
              
            </div>
            <div className="col-lg-5 d-flex justify-content-lg-end">
              <div className="globalsupplier-container">
                <div
                  className="card shadow-lg border-0"
                  style={{
                    borderRadius: "1rem",
                    width: "100%",
                    minWidth: "420px",
                    padding:"20px"
                  }}
                >
                  <div className="card-body p-lg-5 p-4">
                    <div className="text-center">
                      <img
                        src="/assets/images/Zotrai.png"
                        alt={`${DefaultData.DEFAULTBRANDNAME} Logo`}
                        style={{ height: "35px" }}
                        className="mb-3"
                      />
                    </div>
                    <p className="text-muted text-center mb-4">
                      Sign in to continue...
                    </p>
                    {errors.submit && (
                      <div className="alert alert-danger">{errors.submit}</div>
                    )}
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label">
                          Username
                        </label>
                        <input
                          className={`form-control ${applyErrorClass("username")}`}
                          name="username"
                          type="text"
                          value={values.username}
                          onChange={handleInputChange}
                          placeholder="Enter your username"
                        />
                        {/* KEY CHANGE 1: Added error message for username */}
                        {errors.username === false && (
                          <div className="invalid-feedback d-block">
                            Please enter your username.
                          </div>
                        )}
                      </div>
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Password
                          </label>
                        </div>
                        <div className="position-relative">
                          <input
                            className={`form-control pe-5 ${applyErrorClass("password")}`}
                            name="password"
                            type={showPassword ? "text" : "password"}
                            value={values.password}
                            onChange={handleInputChange}
                            placeholder="Enter your password"
                          />
                          <button
                            type="button"
                            className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none text-muted"
                            onClick={togglePasswordVisibility}
                            style={{ right: "0.5rem" }}
                          >
                            <i
                              className={`ri-eye-${showPassword ? "line" : "off-line"} fs-5`}
                            ></i>
                          </button>
                        </div>
                        {/* KEY CHANGE 2: Added error message for password */}
                        {errors.password === false && (
                          <div className="invalid-feedback d-block">
                            Please enter your password.
                          </div>
                        )}
                      </div>
                      <div className="mt-4">
                        <button
                          type="submit"
                          className="btn w-100"
                          style={{
                            backgroundColor: DefaultData.THEMECOLOR1,
                            color: DefaultData.THEMECOLOR3,
                          }}
                          disabled={btnSubmit}
                        >
                          {btnSubmit ? "Signing In..." : "Sign In"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </section>
      </div>
    </div>
  );
}
